export function pluck(key) {
    return (obj) => obj[key];
}
